import { TAGS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(TAGS_ENDPOINT);
export default instance;
